/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Pinned_Voices_LabelInputs */



/**
* | output |
* | --- |
* | "Pinned Voices" |
*
* @param {Voice_Manager_Pinned_Voices_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pinned_voices_label = /** @type {((inputs?: Voice_Manager_Pinned_Voices_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pinned_Voices_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix epinglees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Angeheftete Stimmen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Voci bloccate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрепленные голоса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Voces fijadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("置顶的声音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("固定された音声")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिन की गई आवाज़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vozes Fixadas")
	return /** @type {LocalizedString} */ ("Pinned Voices")
});